var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopFollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.092 0c6.522 0 11.873 5.358 11.873 11.841q-.002.07-.003.14H9.736q.002-.07.003-.14c0-5.264-4.353-9.628-9.647-9.628L0 2.216V.003Zm0 4.106c4.296 0 7.757 3.453 7.757 7.725 0 .047-.006.091-.008.139H5.616c0-.048.007-.092.007-.14A5.506 5.506 0 0 0 .092 6.322q-.046.002-.092.004V4.112c.03 0 .062-.006.092-.006m1.601 4.45c.936 0 1.693.753 1.693 1.683s-.757 1.682-1.693 1.682A1.69 1.69 0 0 1 0 10.24c0-.93.758-1.684 1.693-1.684"
})));
export default SvgFacebookDesktopFollow;